import styled from '@emotion/styled';
import { FC } from 'react';
import { ISubjectAssets } from '@taleemabad/db';
import { Typography, List, Spacing } from '@taleemabad/dsm/components';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';

interface CoursesSubjectCategoryProps {
  allSubjectCategory: ISubjectAssets[];
  onSubjectCategoryClicked: (course: ISubjectAssets) => void;
}
export const TeacherTrainingCoursesSubjectCategory: FC<
  CoursesSubjectCategoryProps
> = ({ allSubjectCategory, onSubjectCategoryClicked }) => {
  return (
    <Spacing padding="xl">
      <TeacherTrainingCourseContainer>
        <Typography variant="textHeadlineMediumOnSurface">
          Subject Courses
        </Typography>

        <StyledCategoryContainer>
          {allSubjectCategory.map((subject) => (
            <List
              onClick={() => {
                onSubjectCategoryClicked?.(subject);
              }}
              key={subject.id}
              alignment="center"
              heading={subject.name}
              leadingIcon={{
                type: 'image',
                direction: 'leading',
                source: subject.icon,
              }}
            />
          ))}
        </StyledCategoryContainer>
      </TeacherTrainingCourseContainer>
    </Spacing>
  );
};
const StyledCategoryContainer = styled.div`
  margin-top: var(--rk-spacing-xxl);
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  gap: var(--rk-spacing-xl);
  ${mq(BreakpointSizes.xs)} {
    display: flex;
    flex-direction: column;
  }
`;
const TeacherTrainingCourseContainer = styled.div``;
